<template>
  <div id="app">
    <div class="live">
      <div
        style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        "
      >
        <el-page-header @back="goBack" :content="courseName"> </el-page-header>
        <el-button size="small" type="primary" @click="exportLive"
          >导出结果</el-button
        >
      </div>
      <el-table
        :header-cell-style="{ background: '#DFE7FC', height: '48px' }"
        :row-style="{ height: '48px' }"
        :data="liveData"
        border
        stripe
        style="width: 100%; margin-top: 15px"
      >
        <el-table-column align="center" prop="viewersName" label="姓名">
        </el-table-column>
        <el-table-column align="center" prop="schoolName" label="学校名称">
        </el-table-column>

        <el-table-column align="center" prop="provinceName" label="省">
        </el-table-column>
        <el-table-column align="center" prop="cityName" label="市">
        </el-table-column
        >
        <el-table-column align="center" prop="countyName" label="区">
        </el-table-column>
        <el-table-column
          align="center"
          prop="viewersDuration"
          label="观看时长（秒）"
        >
        </el-table-column>
        <el-table-column align="center" prop="intoTime" label="进入时间">
        </el-table-column>
        <el-table-column align="center" prop="quitTime" label="退出时间">
        </el-table-column>
        <el-table-column align="center" prop="accessName" label="访问来源">
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :page-size="15"
        style="margin-top:15px;text-align:right;margin-bottom:100px"
        layout="total, prev, pager, next, jumper"
        @current-change="currentChange"
        :total="totalCount"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { liveRoomWatchRecord, dictcode, exportLive } from "@/api/home";
export default {
  data() {
    return {
      lessonId: "",
      courseName: "",
      pageNum: 1,
      pageSize: 15,
      liveData: [],
      totalCount: 0,
      access: [],
    };
  },
  created() {
    this.courseName = this.$route.query.courseName + "观看统计";
    this.lessonId = this.$route.query.lessonId;

    this.dictcode();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    // 分页页码变化
    currentChange(e) {
      this.pageNum = e
      // 调用查询教师列表
      this.liveRoomWatchRecord()
    },
    // 直播间观看记录查询
    liveRoomWatchRecord() {
      let parasm = {
        lessonId: this.lessonId,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      liveRoomWatchRecord(parasm).then((res) => {
        let list = res.data.data.dataList;
        list.forEach((item) => {
          let idx = this.access.findIndex(
            (items) => items.code == item.accessSource
          );
          item.accessName = this.access[idx].name;
        });
        this.liveData = list;
        this.totalCount = res.data.data.totalCount;
      });
    },
    // 获取访问来源
    dictcode() {
      dictcode({
        code: "access_source_type",
      }).then((res) => {
        this.access = res.data.data;
        this.liveRoomWatchRecord();
      });
    },
    // 导出观看统计
    exportLive() {
      let params = {
        lessonId: this.lessonId,
      };
      exportLive(params, this.courseName);
    },
  },
};
</script>
<style scoped>
.live {
  margin: 0px auto;
  max-width: 1600px;
}
</style>



// WEBPACK FOOTER //
// src/components/public/liveStat.vue